export default __webpack_public_path__ + "static/media/arrow_down_small.09c15222.svg";